import React, { useState, useEffect } from 'react';
import { merchAPI } from '../services/api';

function Merch() {
  const [merch, setMerch] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadMerch();
  }, []);

  const loadMerch = async () => {
    try {
      const response = await merchAPI.getAll();
      const data = response?.data || [];
      const merchArray = Array.isArray(data) ? data : [];
      // Reverse to show newest first, show only first 8
      setMerch([...merchArray].reverse().slice(0, 8));
    } catch (error) {
      console.error('Error loading merch:', error);
      setMerch([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section id="merch" className="merch-section">
        <div className="container">
          <h2 className="section-title">MERCH</h2>
          <div className="merch-grid">
            <p style={{ color: '#a0a0a0', textAlign: 'center', gridColumn: '1 / -1' }}>Loading merch...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="merch" className="merch-section">
      <div className="container">
        <h2 className="section-title">MERCH</h2>
        <div className="merch-grid">
          {!Array.isArray(merch) || merch.length === 0 ? (
            <div style={{ gridColumn: '1 / -1', textAlign: 'center', color: '#a0a0a0' }}>
              <p>No merch available yet.</p>
            </div>
          ) : (
            merch.map((item) => (
              <a
                key={item.id}
                href={item.bandcampUrl || 'https://sloomweepproductions.bandcamp.com/'}
                target="_blank"
                rel="noopener noreferrer"
                className="merch-card"
              >
                <div 
                  className="merch-image-placeholder"
                  style={item.image ? {
                    backgroundImage: `url(${item.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  } : {}}
                ></div>
                <h3 className="merch-name">{item.name}</h3>
              </a>
            ))
          )}
        </div>
        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <a
            href="https://sloomweepproductions.bandcamp.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#228b22',
              textDecoration: 'none',
              fontSize: '1.2rem',
              fontFamily: 'Bungee, cursive',
              border: '2px solid #228b22',
              padding: '12px 30px',
              display: 'inline-block',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#228b22';
              e.target.style.color = '#000';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#228b22';
            }}
          >
            VIEW ALL ON BANDCAMP →
          </a>
        </div>
      </div>
    </section>
  );
}

export default Merch;
